<template>
  <div class="tooltip-discount-cover">
    <div class="text">折扣標籤將會在封面圖片出現</div>
    <div class="cover-wrapper">
      <img :src="cover || require('../../assets/img/tooltip_default.png')" />
      <div class="flag">
        <span>{{ tagName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipDiscountCover',
  props: {
    tagName: {
      type: String,
    },
    cover: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-discount-cover {
  position: relative;
  height: 222px;
  width: 198px;
  border: 1px solid #b1d8fb;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(40, 111, 178, 0.1);
  padding: 10px 14px;
  overflow: hidden;

  & img {
    width: 100%;
  }

  & .text {
    color: #318ce1;
    font-family: 'PingFang TC';
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    padding-bottom: 10px;
  }

  & .cover-wrapper {
    overflow: hidden;
    position: relative;
  }

  & .flag {
    position: absolute;
    right: -57px;
    height: 77px;
    width: 138px;
    text-align: center;
    transform: rotate(45deg);
    background: #f27d51;
    top: -17px;
    font-size: 12px;
    opacity: 1;
    text-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    font-family: 'PingFang TC';

    span {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
        'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
        'Noto Color Emoji';
      color: #fff;
      position: absolute;
      bottom: 3px;
      left: calc(28% + 0px);
    }
  }
}
</style>
